/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Body {
  /**
   * 活动ID
   */
  event_id: string;
  /**
   * 来源：0-默认；1-活动大厅预览
   */
  source?: number;
  /**
   * 封面样式
   */
  image_type?: string;
  /**
   * 其他可选数据：1表示返回观众人数
   */
  extra_type?: number;
}
export type Labels = string[];
/**
 * 场地类型，1大型会场，2圆桌讨论
 */
export type VenueType = number[];
export interface PublicEventGetEventInfoRes {
  code?: number;
  msg?: string;
  data: Data;
  nonce?: string;
}
export interface Data {
  event_info?: EventInfo;
}
export interface EventInfo {
  /**
   * 主办方ID
   */
  host_id?: string;
  /**
   * 时区
   */
  time_zone?: string;
  /**
   * 活动标题
   */
  title?: string;
  /**
   * 活动地址
   */
  address?: string;
  /**
   * 活动结束时间
   */
  end_time?: number;
  /**
   * 活动开始时间
   */
  start_time?: number;
  /**
   * 活动ID
   */
  event_id?: string;
  /**
   * 模板类型名
   */
  template?: string;
  /**
   * 活动行业分类名
   */
  industry_name?: string;
  /**
   * 活动状态，未发布0，已发布1，发布中2，发布失败3， 修改发布中4，修改失败5
   */
  status?: number;
  cover_cos_id?: string;
  /**
   * 封面图url
   */
  cover_url?: string;
  /**
   * 活动类型，-1为旧版webinar，0位新版活动
   */
  event_type?: number;
  labels?: Labels;
  /**
   * 是否公开，0为不公开，1为公开
   */
  is_public?: number;
  /**
   * 行业分类编码
   */
  industry_code?: string;
  /**
   * 主办方名称
   */
  host_name?: string;
  /**
   * 收费类型（免费传1，付费传2，免费+付费传3）
   */
  charge_type?: number;
  webinar_fields?: WebinarFields;
  venue_type?: VenueType;
  /**
   * 准入规则 0-门票 1-无限制
   */
  access_rule: number;
  extra_data?: ExtraData;
}
export interface WebinarFields {
  short_link?: string;
  meeting_id?: string;
  meeting_code?: string;
}
/**
 * 根据extra_type返回其他信息
 */
export interface ExtraData {
  /**
   * 嘉宾数量
   */
  audience_count?: number;
}

const PublicEventGetEventInfo = async (data: Body, ctx?: GetServerSidePropsContext) => {
  const res = await http.post<PublicEventGetEventInfoRes>(
    '/wemeet-tapi',
    '/v2/activities/public/event/get-event-info',
    data,
    ctx,
  );

  return res;
};

export default PublicEventGetEventInfo;
